@use "../../design-tokens/typography/typography" as *;
@use "../../design-tokens/border-radius/border-radius" as *;

@keyframes network-graph-spin {
  to {
    transform: rotate(360deg);
  }
}

@layer design-system {
  .root {
    --network-graph-edge-stroke-width: 1.25;

    @include border-radius-r2;
    position: relative;
    width: 100%;
    background-color: var(--background-default);
  }

  .canvas {
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    cursor: grab;
    touch-action: none;
    user-select: none;

    &[data-panning] {
      cursor: grabbing;
    }
  }

  .edgeGroup {
    color: var(--border-default);

    &[data-emphasis="soft"] {
      color: var(--border-soft);
    }

    &[data-emphasis="selected"] {
      --network-graph-edge-stroke-width: 2;
      color: var(--border-primary);
    }

    &:hover:not([data-emphasis="selected"]),
    &[data-hovered]:not([data-emphasis="selected"]) {
      color: var(--surface-inverse);
    }
  }

  .edge {
    fill: none;
    stroke: currentcolor;
    stroke-linecap: round;
    stroke-width: var(--network-graph-edge-stroke-width);
  }

  .edgeHitArea {
    fill: none;
    stroke: transparent;
    stroke-width: 24;
    pointer-events: stroke;

    &[data-clickable] {
      cursor: pointer;
    }
  }

  .edgeLabelGroup {
    color: var(--text-soft);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.15s ease;

    &[data-visible] {
      opacity: 1;
    }
  }

  .edgeLabelBackground {
    fill: var(--background-default);
  }

  .edgeLabel {
    @include typography-v2-body-xs;
    fill: currentcolor;
    text-anchor: middle;
    dominant-baseline: central;
  }

  .edgeTooltipObject {
    overflow: visible;
    pointer-events: none;
  }

  .node {
    cursor: default;

    &[data-interactive] {
      cursor: pointer;
    }

    &[data-state="active"] .nodeLabel {
      @include typography-v2-title-sm;
      fill: var(--text-primary);
    }

    &[data-state="active"] .nodeLabelBackground {
      fill: var(--background-default);
    }

    &:hover .nodeLabelGroup {
      opacity: 1;
    }
  }

  .nodeVisual {
    transform-box: fill-box;
    transform-origin: center;
    transition:
      filter 0.15s ease,
      transform 0.15s ease;
  }

  .activeContentObject {
    overflow: visible;
  }

  .loadingRing {
    fill: none;
    stroke: var(--node-accent);
    stroke-dasharray: 18 10;
    stroke-linecap: round;
    stroke-width: 2;
    transform-box: fill-box;
    transform-origin: center;
    animation: network-graph-spin 0.9s linear infinite;
  }

  .nodeLabelGroup {
    opacity: 0;
    pointer-events: none;

    transition: none;

    &[data-visible] {
      opacity: 1;
      transition: opacity 0.15s ease;
    }
  }

  .nodeLabelBackground {
    fill: transparent;
  }

  .nodeLabel {
    @include typography-v2-body-xs;
    fill: var(--text-default);
    text-anchor: middle;
    dominant-baseline: central;
  }

  .zoomControls {
    position: absolute;
    top: 12px;
    left: 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .zoomButton {
    @include border-radius-full;
  }
}
